import { render, staticRenderFns } from "./OctDialog.vue?vue&type=template&id=37cc6a99&scoped=true&"
import script from "./OctDialog.vue?vue&type=script&lang=js&"
export * from "./OctDialog.vue?vue&type=script&lang=js&"
import style0 from "./OctDialog.vue?vue&type=style&index=0&id=37cc6a99&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc6a99",
  null
  
)

export default component.exports